/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-01.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { GuideWrap, GuideImgWrap } from '../index.style'

const FirstBetPopup: React.FC = () => {
  const { globalStore, userStore } = useRootStore()
  const { visibleFirstBetPopup } = globalStore

  const goalValue = Number(userStore.settlementSupport ? userStore.settlementSupport.achieveGoalValue : 0)
    .toLocaleString()
  const totalBetMoney = Number(userStore.settlementSupport ? userStore.settlementSupport.totalBetMoney : 0)
    .toLocaleString()
  const reward = globalStore.getFirstBetMoneyReward().toLocaleString()

  const onCloseModal = async () => {
    globalStore.setVisibleFirstBetPopup(false)
  }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleFirstBetPopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="adv-new-dialog box-type big-size character-popup"
        wrapClassName="guide-notice-popup"
        css={AdvDialogStyle}
      >
        {/* 캐릭터 영역 */}
        <GuideImgWrap>
          <div className="guide-circle">
            <img src={GuideCharacter} alt="캐릭터" className="guide-character"/>
          </div>
          <p className="guide-txt">
            첫 베팅에 성공하셨네요!
            <br/>
            목표를 달성하고 보상을 획득하세요!
          </p>
        </GuideImgWrap>

        <GuideWrap>
          <div className="guide-box goal">
            <span className="guide-box--tit">목표</span>
            <span className="guide-box--txt">
              누적 베팅머니<br/>
              <span className="value">{goalValue}</span>
              <GmoneyIco/>
            </span>
          </div>

          <div className="guide-box goal">
            <span className="guide-box--tit">현재</span>
            <span className="guide-box--txt">
              누적 베팅머니<br/>
              <span className="value">{totalBetMoney}</span>
              <GmoneyIco/>
            </span>
          </div>

          <div className="guide-box reward">보상: <span className="point-color--orange--modal">{reward}</span><GmoneyIco/></div>
        </GuideWrap>

        <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} className="single-btn">
            확인
          </Button>
        </AdvDialogBtnWrap>

        <ModalBg onClick={onCloseModal}/>
      </Modal>
    </Fragment>
  )
}

export default observer(FirstBetPopup)
